import * as types from '../mutations-types'

// STATE
const state = {
  placeSelected: false,
  placeSelectedLocation: null
}

// GETTERS
const getters = {
  placeSelected: state => state.placeSelected,
  placeSelectedLocation: state => state.placeSelectedLocation
}

// MUTATIONS
const mutations = {
  [types.SET_PLACE_SELECTED](state, value) {
    state.placeSelected = value
  },
  [types.SET_PLACE_SELECTED_LOCATION](state, payload) {
    state.placeSelectedLocation = payload
  }
}

// ACTIONS
const actions = {
  setPlaceSelected({ commit }, value) {
    commit(types.SET_PLACE_SELECTED, value)
  },
  setPlaceSelectedLocation({ commit }, payload) {
    commit(types.SET_PLACE_SELECTED_LOCATION, payload)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/places.js